import {
  CUSTOMER_RANK_SUCCESS,
  CUSTOMER_RANK_FAIL,
  CUSTOMER_RANK_PENDING,
  ADD_CUSTOMER_RANK_SUCCESS,
  ADD_CUSTOMER_RANK_FAIL,
  ADD_CUSTOMER_RANK_PENDING,
  UPDATE_CUSTOMER_RANK_SUCCESS,
  UPDATE_CUSTOMER_RANK_PENDING,
  UPDATE_CUSTOMER_RANK_FAIL,
} from "../../actions/types";

const initialState = {
  customerRank: [],
  addCustomerRank: '',
  updateCustomerRank: '',
  loading: false,
  isCustomerRankLoading: false,
};

const customer_rank_reducer = (state = initialState, action) => {
  const { type, payload } = action;
  
  switch (type) {
    case CUSTOMER_RANK_PENDING:
      return {
        ...state,
        loading: true,
        isCustomerRankLoading: true,
      };
    case CUSTOMER_RANK_SUCCESS:
      return {
        ...state,
        customerRank: payload.customerRank,
        loading: false,
        isCustomerRankLoading: false,
      };
    case CUSTOMER_RANK_FAIL:
      return {
        ...state,
        customerRank: [],
        loading: false,
        isCustomerRankLoading: false,
      };
    case ADD_CUSTOMER_RANK_PENDING:
      return {
        ...state,
        loading: true,
      };
    case ADD_CUSTOMER_RANK_SUCCESS:
      return {
        ...state,
        addCustomerRank: payload.addCustomerRank,
        loading: false,
      };
    case ADD_CUSTOMER_RANK_FAIL:
      return {
        ...state,
        addCustomerRank: false,
        loading: false,
      };
    case UPDATE_CUSTOMER_RANK_PENDING:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CUSTOMER_RANK_SUCCESS:
      return {
        ...state,
        updateCustomerRank: payload.updateCustomerRank,
        loading: false,
      };
    case UPDATE_CUSTOMER_RANK_FAIL:
      return {
        ...state,
        updateCustomerRank: false,
        loading: false,
      };
    default:
      return state;
  }
};

export default customer_rank_reducer;
